import * as _cr from "./_cr";
import * as _hm from "./_hm";
import * as _ht from "./_ht";

import { a } from "./_cmABT";

import * as BoxC from "./_ccbBoxC";
import * as BtnC from "./_cccBtnC";
import * as SrlC from "./_ccbSrlC";

import * as IptC from "./_ccbIptC";

import { useMdlz } from "./_csMdl";
import * as _csLcl from "./_csLcl";

let $word = '';

export const useMdlSchz = () => {
  const _sMdlz = useMdlz();
  const _udtThis = _csLcl.udtThis();
  const _show = (pz: {
    ls?: _ht.ls,
    onPrs: ( _dz: _ht.dz ) => void,
    bUdt?: _ht.b, 
  }) => {
//_hm.l(`csMdlSch 24: ${_hm.s(pz.ls)}`);
    if (pz.bUdt != true) $word = '';
    const _dw = _cr.d('p') ? 60 : 40;
    const _ls = [
      _cr.c(BoxC.N, {
        key: -10,
        boxStlz: a(`br/1 dw/${_dw} dh/70 fd/csc p/1 sc/lt1`), // dhx でなく dh
        boxClds: [
          _cr.c(BoxC.N, {
            key: -10,
            boxStlz: a(`dw/f fd/rsc mb/2`),
            boxClds: [
              _cr.c(BoxC.N, {
                key: -10,
//                boxStlz: a(`dw/40 sc/rd2`),
                boxStlz: a(`f/1`),
                boxClds: [
                  _cr.c(IptC.N, {
                    key: -10,
    //                boxStlz: a(`f/1`),
                    cz: {
                      iptType: 't',
                      bEdit: true,
                      vle: $word,
                      onChg: (_s: _ht.s) => {
                        $word = _s;
                      }
                    }
                  }),
                ]
              }),
              _cr.c(BtnC.N, {
                key: -20,
/*
                bfrIconCz: {
                  iconPtyz: a("icc/lt1 icn/search ics/2"),
                },
*/
                lblCz: {
//                  boxStlz: a(`ml/0.5`),
                  text: '検索',
                  textStlz: a(`tc/lt1`),
                },
                frmCz: {
//                  boxStlz: a(`br/1 dw/10 fd/rcc ml/0.5 pv/0.5 sc/lt5`),
                  boxStlz: a(`br/1 dw/10 fd/rcc ml/0.5 pv/0.5 sc/rd5`),
                  pslStlz: a(`dh/n dw/n`),
                  pslPtyz: {
                    onPrs: () => {
                      //_hm.l(`MdlSch 70: here`)
                      _show({ ... pz, bUdt: true }); // 再描画
                    },
                  },
                },
              }),
            ]
          }),
          _cr.c(BoxC.N, {
            key: -20,
            boxStlz: a(`dw/f f/1 fd/css`),
            boxClds: [
              _cr.c(SrlC.N, {
                key: -10,
                srlClds:
//                  pz.ls?.filter((_dz: _ht.dz) => $word == '' || _dz.pfx.indexOf($word) >= 0)
                  pz.ls?.filter((_dz: _ht.dz) => {
                    const _b = !_hm.f($word) || !_dz.sch || (_dz.sch && _dz.sch?.indexOf($word) >= 0);
                    //_hm.l(`MdlSch 88: ${_b}, ${$word}, ${_dz.sch}, ${_dz.sch?.indexOf($word)}`)
                    return _b;
                  })
                  .map((_dz: _ht.dz, _idx: _ht.n) => (
                    _cr.c(BtnC.N, {
                      key: _idx,
                      lblCz: {
    //                    boxStlz: a(`dw/f`),
/*
                        textz: {
                          text: _dz.pfx,
                          ptyz: a(`tn/1`),
                        },
*/
                        text: _dz.text,
                        textPtyz: a(`tn/1`),
                      },
                      frmCz: {
                        boxStlz: a(`bc/lt5 bs/ds bwt/${_idx == 0 ? 0 : 0.5} dw/${_dw - 2} fd/rsc pv/1 ph/1`),
                        pslPtyz: {
                          onPrs: () => {
                            if (pz.onPrs) pz.onPrs(_dz);
                            _sMdlz.set({
                              bShow: false,
                            });
                          },
                        },
                      },
                    })
                  ))
              })
            ]
          })
        ]
      })
    ];
    //hf.l('ipt 44: here');
    _sMdlz.set({
      bShow: true,
      mdlClds: _ls
    })
  }
  return {
    show: _show
  }
};
